import React from "react";
import { parsal_img } from "../../../assets/mediaCall";
const AppDownloadSection = () => {
  return (
    <div className="relative w-[85vw] lg:w-[90vw] smp:w-[96vw] mx-auto inter max-h-[613px] mdg:max-h-[774px]  mt-40 xl:mt-32 mdg:mt-2 mb-10 xs:mb-6 flex mdg:flex-col justify-center lg:justify-start items-center px-10 lg:px-6 mlg:px-0 smp:px-0 pt-16 mdg:pt-0 pb-28 mlg:pb-20 mdg:pb-4 gap-6 bg-[#FFFFFF] ">
      <div className="hidden mdg:block w-[50%] smm:w-[60%] smp:w-[66%] z-20">
        <img
          src={parsal_img.download}
          alt="App Screen 2"
          className="w-full h-full object-contain max-h-[704px] sm:max-h-[403px]"
        />
      </div>
      {/* Left Section */}
      <div className="w-[90%] mdg:w-[80%] smm:w-[90%] mdg:pl-10 sm:pl-0 pl-10 xxl:pl-0 xs:pl-0">
        <h4 className=" font-semibold text-gray-500 uppercase mb-2 mlg:hidden">
          Download
        </h4>
        <div className="mt-4 mdg:hidden block">
          <h1 className="text-3xl  font-extrabold text-black ">
            Download the Parsal
          </h1>
          <h1 className="text-3xl font-extrabold text-black mb-4">
            Logistic App
          </h1>
        </div>
        <div className="mt-4 hidden mdg:block ">
          <h1 className="text-3xl sm:text-2xl font-extrabold text-black mb-4 ">
            Download the Parsal Logistic App
          </h1>
        </div>

        <p className="text-gray-600 font-semibold mb-6 smp:hidden">
          <span>Get the App for free. Click the button below to</span>
          <br />
          <span>download the App</span>
        </p>

        <div className="flex space-x-4">
          <div>
            <img
              src={parsal_img.appstore} // Replace with the correct path
              alt="Download on the App Store"
              className="w-44 h-auto"
            />
          </div>
          <div>
            <img
              src={parsal_img.playstore} // Replace with the correct path
              alt="Get it on Google Play"
              className="w-44 h-auto"
            />
          </div>
        </div>
      </div>
      {/* Right Section */}
      {/* <div className="relative w-[40%] mlg:w-[50%] sm:w-[80%] ">
        <div className="z-10">
          <img
            src={parsal_img.ellipse4}
            alt="App Screen 1"
            className="max-w-[362px] mx-auto max-h-[423px] w-[65%] sm:max-h-[256px]"
          />
        </div>
      
      </div> */}
      <div className="mdg:hidden w-[50%] absolute top-[-47%] xxl:top-[-30%] right-[5%] xxl:right-[2%] mlg:right-0 sm:right-[15%] z-20">
        <img
          src={parsal_img.download}
          alt="App Screen 2"
          className="w-full h-full object-contain max-h-[704px] sm:max-h-[403px]"
        />
      </div>
    </div>
  );
};
export default AppDownloadSection;
